import { Modal } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CompanyCreditLineDetails from '../../company-credit-line-details/component';
import CompanyIndividualPlaidPaymentComponent from '../../company-individual-plaid-payment/component';
import { axiosInstanceB2B, formatAmount, Toaster } from '@share/utils';
import { ILoginState } from '@share/store/slices';
import { Urls } from '@share/constants';
import {
  removeSelectedCreditLineData,
  setCreditLineData,
  setCreditLineSummary,
  setDueAmount,
} from '@store/slices';
import './style.scss';
import { useIntl } from 'react-intl';

interface CreditLineInvoicesProps {
  text: number;
}
interface IMapStateToProps {
  loginStore: ILoginState;
}
const CreditLineInvoices: React.FC<CreditLineInvoicesProps> = ({ text }) => {
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const creditLineInvoices = useSelector((state: any) =>
    state?.creditLineStore?.creditLine?.find((item: any) => item?.creditLineInvoiceId === text),
  );
  const bankName = useSelector((state: any) => state?.creditLineStore?.bankName);
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isBankloading, setIsBankLoading] = useState<boolean>(false);
  const [isPaymentloading, setPaymentLoading] = useState<boolean>(false);
  const [bankListModalVisible, setBankListModalModalVisible] = useState<boolean>(false);

  const [amount, setAmount] = useState<number>(creditLineInvoices?.amount || 0);
  const [checked, setChecked] = useState<{ creditLineInvoiceDetailId: number[] }>({
    creditLineInvoiceDetailId: [],
  });
  const [selectedBank, setSelectedBank] = useState<{
    bankId: number;
    bankName: string;
    lastFourDigits: string;
    bankType: string;
    loading: boolean;
  } | null>(null);
  const handleCheckboxChange = (event: any, record: any) => {
    const isChecked = event.target.checked;
    const { creditLineInvoiceDetailId } = record;

    setChecked((prev) => {
      let updatedIds = [...prev.creditLineInvoiceDetailId];

      if (isChecked) {
        if (!updatedIds.includes(creditLineInvoiceDetailId)) {
          updatedIds.push(creditLineInvoiceDetailId);
        }
      } else {
        updatedIds = updatedIds.filter((id) => id !== creditLineInvoiceDetailId);
      }

      return {
        creditLineInvoiceDetailId: updatedIds,
      };
    });
  };

  const modalWidth = 600;

  const handleOpenModal = (text: number) => {
    setIsModalVisible(true);
  };
  const handleCloseModal = () => {
    setChecked({ creditLineInvoiceDetailId: [] });
    setIsModalVisible(false);
  };

  async function getCreditLineInvoiceSummary() {
    try {
      const result = await axiosInstanceB2B.get(
        `${Urls.getCreditLineInvoiceSummary}/${login?.account?.id}`,
      );
      if (result?.status === 200) {
        const { data } = result;
        dispatch(
          setCreditLineSummary({
            totalPending: formatAmount(data?.totalPending),
            dueDate: data?.dueDate,
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleBankSelection = (event: React.ChangeEvent<HTMLInputElement>, bank: any) => {
    setSelectedBank((prev) => {
      return {
        ...prev,
        bankId: bank?.bankId,
        bankName: bank?.bankName,
        lastFourDigits: bank?.lastFourDigits,
        bankType: bank?.bankType,
        loading: false,
      };
    });
  };

  const handleBankListModalClose = () => {
    setBankListModalModalVisible(false);
    setSelectedBank(null);
    handleOpenModal(text);
  };
  const handleBankListModalOpen = () => {
    setBankListModalModalVisible(true);
    setIsModalVisible(false);
    const checkedIds = new Set(checked.creditLineInvoiceDetailId);

    const deductionAmount = creditLineInvoices.creditLineInvoiceDetails
      .filter((detail: any) => checkedIds.has(detail.creditLineInvoiceDetailId))
      .reduce((sum: any, detail: any) => sum + detail.amount, 0);
    const updatedAmount = creditLineInvoices.amount - deductionAmount;
    setAmount(updatedAmount);
  };

  // const handleProceed = async () => {
  //   if (!selectedBank) return;

  //   try {
  //     setSelectedBank((prev) => (prev ? { ...prev, loading: true } : null));

  //     const payload = {
  //       BankId: selectedBank.bankId,
  //       Amount: '0.03',
  //       // Amount: formatAmount(amount) + "",
  //       AccountId: login?.account?.id,
  //       CreditLineInvoicePaids: [
  //         {
  //           CreditLineInvoiceId: creditLineInvoices.creditLineInvoiceId,
  //           ...(checked.creditLineInvoiceDetailId.length > 0 && {
  //             CreditLineInvoiceDetailExcluded: checked.creditLineInvoiceDetailId.map((id) => ({
  //               creditLineInvoiceDetailId: id,
  //             })),
  //           }),
  //         },
  //       ],
  //     };

  //     // Process payment
  //     const paymentResponse = await axiosInstanceB2B.post(Urls.ACHPaymentDebit, payload);

  //     if (paymentResponse?.status === 200) {
  //       setTimeout(async () => {
  //         const { data: invoiceData } = await axiosInstanceB2B.get(
  //           Urls.CreditLineInvoicesByPaidDate,
  //         );

  //         if (invoiceData?.items) {
  //           const { items } = invoiceData;
  //           dispatch(setCreditLineData(items));
  //           dispatch(removeSelectedCreditLineData(creditLineInvoices?.creditLineInvoiceId));
  //           await getCreditLineInvoiceSummary();
  //           Toaster.success(paymentResponse.data.message);
  //           setBankListModalModalVisible(false);
  //           setSelectedBank(null);
  //         }
  //       }, 120000);
  //       setPaymentLoading(true);
  //       setTimeout(() => {
  //         Toaster.info('Please wait for a minute we are processing your payment!');
  //       }, 1500);
  //     } else {
  //       setPaymentLoading(false);
  //       throw new Error('Payment failed. Please try again.');
  //     }
  //   } catch (error) {
  //     setPaymentLoading(false);
  //     console.error('Payment Error:', error);
  //     Toaster.error('An error occurred. Please try again.');
  //   } finally {
  //     setSelectedBank((prev) => (prev ? { ...prev, loading: false } : null));
  //   }
  // };
  const handleProceed = async () => {
    if (!selectedBank) return;
  
    setSelectedBank((prev) => (prev ? { ...prev, loading: true } : null));
  
    const payload = {
      BankId: selectedBank.bankId,
      Amount: '0.03',
      AccountId: login?.account?.id,
      CreditLineInvoicePaids: [
        {
          CreditLineInvoiceId: creditLineInvoices.creditLineInvoiceId,
          CreditLineInvoiceDetailExcluded: checked.creditLineInvoiceDetailId.map((id) => ({
            creditLineInvoiceDetailId: id,
          })),
        },
      ],
    };
  
    try {
      const paymentResponse = await axiosInstanceB2B.post(Urls.ACHPaymentDebit, payload);
  
      if (paymentResponse?.status !== 200) {
        throw new Error('Payment failed. Please try again.');
      }
  
      setPaymentLoading(true);
      Toaster.info('Please wait for a minute, we are processing your payment!');
  
      setTimeout(async () => {
        try {
          const { data: invoiceData } = await axiosInstanceB2B.get(Urls.CreditLineInvoicesByPaidDate);
          if (invoiceData?.items) {
            dispatch(setCreditLineData(invoiceData.items));
            dispatch(removeSelectedCreditLineData(creditLineInvoices?.creditLineInvoiceId));
            await getCreditLineInvoiceSummary();
            Toaster.success(paymentResponse.data.message);
            setBankListModalModalVisible(false);
            setSelectedBank(null);
            setPaymentLoading(false);
          }
        } catch (error) {
          console.error('Invoice Fetch Error:', error);
        }
      }, 120000);
    } catch (error) {
      console.error('Payment Error:', error);
      Toaster.error('An error occurred. Please try again.');
    } finally {
      setPaymentLoading(false);
      setSelectedBank((prev) => (prev ? { ...prev, loading: false } : null));
    }
  };
  const intl = useIntl();
  return (
    <>
      <span className="invoiceLink" onClick={() => handleOpenModal(text)}>
        {text}
      </span>
      <Modal
        title={intl.formatMessage({ id: 'invoice.summary' })}
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width={modalWidth}
      >
        <CompanyCreditLineDetails
          record={creditLineInvoices}
          checked={checked}
          handleCheckboxChange={handleCheckboxChange}
          handleBankSelection={handleBankSelection}
          handleBankListModalClose={handleBankListModalClose}
          handleBankListModalOpen={handleBankListModalOpen}
          handleCloseModal={handleCloseModal}
          isPaymentloading={isPaymentloading}
        />
      </Modal>

      <Modal
        title={intl.formatMessage({ id: 'account.plaid.label' })}
        open={bankListModalVisible}
        onCancel={handleBankListModalClose}
        footer={null}
        width={modalWidth}
        className="plaidModal"
      >
        <CompanyIndividualPlaidPaymentComponent
          bankName={bankName}
          selectedBank={selectedBank}
          handleProceed={handleProceed}
          handleBankSelection={handleBankSelection}
          isBankLoading={isBankloading}
          creditLineInvoices={creditLineInvoices}
          amount={amount}
        />
      </Modal>
    </>
  );
};
export default CreditLineInvoices;
